module.exports = __webpack_public_path__ + "img/DK13737584.7d7068d6.png";